import { Link } from 'react-router-dom';
import { localizePath } from '@/utils/languageRoutes';

const LOGO_URL = 'https://scmtfyjpaivqbafbtooy.supabase.co/storage/v1/object/public/dcl_website_asset/dcl_logo/Duru-Compliance-Logo.png';

interface LogoProps {
  language: string;
}

const Logo = ({ language }: LogoProps) => {
  return (
    <Link to={localizePath('/', language)} className="flex items-center">
      <img
        src={LOGO_URL}
        alt="DCL Logo" 
        className="h-10 w-auto"
        loading="eager"
        fetchPriority="high"
        decoding="async"
      />
    </Link>
  );
};

export default Logo;
